import * as Yup from 'yup'
import { ErrorMessage, Form, Formik } from 'formik'
import { useMemo, useRef, useState } from 'react'
import { ROUTES_PATH } from '../../../utility/constants'
import BreadCrumbs from '../../../components/breadcrumb/Breadcrumb'
import Calendar from '../../../components/calendar/Calendar'
import PageDropdown from '../../../components/page-dropdown/PageDropdown'
import Button from '../../../components/button/Button'
import { useDispatch, useSelector } from 'react-redux'
import {
  convertDateFormatCalendar,
  exportStudentReport,
  generateDropdownOptions,
} from '../../../utility/genricFunction'
import './kitSummaryReport.scss'
import ReportDataTable from '../../../components/report-table/ReportDataTable'
import { getKitSummaryReport } from '../../../store/builders/reports/reports.builder'
import PrintIcon from '@mui/icons-material/Print';
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import { useReactToPrint } from 'react-to-print'
import Loader from '../../../components/loader/Loader'

const KitSummaryReport = () => {
  const dispatch = useDispatch()
  const [showTable, setShowTable] = useState(false)
  const { kitSummaryReportData, loading } = useSelector((state) => state?.reports)

  const branches = useSelector((state) => state?.branch?.branchTableData)
  const branchOption = useMemo(() => generateDropdownOptions(branches, 'branchName', 'branchId'), [branches])

  const userRole = useSelector((store) => store?.auth?.user?.result?.userData?.roleName)
  const branchId = useSelector((store) => store?.auth?.user?.result?.userData?.branchId)

  const [initialValues] = useState({
    fromDate: '',
    toDate: '',
    branch: userRole == "branch" ? branchId : '',
  })

  const printRef = useRef()

  const handleDownloadPfd = useReactToPrint({
    content: () => printRef.current,
});

  const validationSchema = Yup.object().shape({
    fromDate: Yup.date().required('From Date is required').typeError('Invalid Date'),
    toDate: Yup.date().required('To Date is required').typeError('Invalid Date'),
    branch: Yup.string().required('Branch is required'),
  })

  const breadCrumbsArr = [
    {
      title: 'Kit Summary Report',
      link: null,
    },
    {
      title: 'Dashboard',
      link: ROUTES_PATH.DASHBOARD,
    },
    {
      title: 'Kit Summary Report',
      link: ROUTES_PATH.KIT_SUMMARY_REPORT,
    },
  ]

  const columns = [
    {
      field: 'id',
      header: '#',
      filter: false,
      style: { minWidth: '2rem' },
    },
    {
      field: 'material_name',
      header: 'Material',
      filter: false,
      style: { minWidth: '12rem' },
    },
    {
      field: 'total_qty',
      header: 'Opening Qty',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '10rem' },
    },
    {
      field: 'transfer_qty',
      header: 'IN Qty(Transfer)',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '10rem' },
    },
    {
      field: 'balance_qty',
      header: 'Balance Qty',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '10rem' },
    },
  ]

  return (
    <>
    {loading && <Loader loading={loading} />}
    {<Loader loading={loading} /> &&  <div className='kit-summary-report-wrapper'>
      <Formik
        initialValues={initialValues}
        enableReinitialize
        onSubmit={(value) => {
          setShowTable(true)
          const data = { branchId: value.branch, startDate: value.fromDate, endDate: value.toDate }
          dispatch(getKitSummaryReport(data))
        }}
        validationSchema={validationSchema}
      >
        {({ values, handleChange, setFieldValue }) => (
          <Form>
            <div className='time-table-report-header'>
              <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />
            </div>
            <div className='time-table-report-main-div'>
              <div className='time-table-report-input-fields'>
                <Calendar
                  label='From Date'
                  name='fromDate'
                  required={true}
                  width={'25%'}
                  onChange={(values) => {
                    setFieldValue('fromDate', convertDateFormatCalendar(values))
                  }}
                />
                <Calendar
                  label='To Date'
                  name='toDate'
                  required={true}
                  width={'25%'}
                  value={values.toDate}
                  onChange={(values) => {
                    setFieldValue('toDate', convertDateFormatCalendar(values))
                  }}
                />
                <div className='time-table-report-dropdown'>
                  <label htmlFor=''>
                    Branch<span className='required-symbol'>*</span>
                  </label>
                  <PageDropdown
                    className={'facultyForm-dropdown'}
                    name={'branch'}
                    placeholder={'Select Branch'}
                    options={branchOption}
                    selectedValue={values.branch}
                    onChange={handleChange}
                    disabled={userRole == "branch"}
                  />
                  <ErrorMessage name='branch' component='div' className='error-msg' />
                </div>
                <div className='submit-btn-wrapper'>
                  <Button type='submit' customClassName={'tt-report-btn-submit'}>
                    Submit
                  </Button>
                </div>
              </div>
            </div>
            {showTable && (
              <div className='kit-summary-report-table-div'>
                <div className='export-option-wrapper'>

                  <div className='pdf-excel-export'>
                    <Button
                      text={'Export'}
                      type={'button'}
                      onClick={() =>
                        exportStudentReport(
                          kitSummaryReportData,
                          columns,
                          'Kit Summary Report',
                          'KitSummaryReport.xlsx',
                        )
                      }
                    >
                      <SimCardDownloadIcon />
                    </Button>
                    <Button
                      text={'Export'}
                      type={'button'}
                      onClick={handleDownloadPfd}
                    ><PrintIcon />
                    </Button>
                  </div>
                </div>

                <div className='printable-component' ref={printRef}>
                <ReportDataTable columns={columns} value={kitSummaryReportData} />
                </div>

              </div>
            )}
          </Form>
        )}
      </Formik>
    </div>}
    </>
  )
}

export default KitSummaryReport
